module.exports = __webpack_public_path__ + "static/Group5999@2x-9212081c1f752933a96e48dc8a1d2bf2.png";